<template>
  <div class="lp-sort-drop-down-container" :style="containerStyle">

    <!-- Basic -->
    <div class="sort-drdn-select-wrapper" @click="openList" :style="wrapperStyle">
      <div class="sort-drdn-select-item" @click.stop.prevent="openList">
        <div v-if="hasImg" style="display: flex; width: 40px;">
          <img :src="selectedImg">
        </div>
        {{ selectedVal }}
      </div>
      <i v-if="!isOpen" @click.stop.prevent="isOpen=true" class="material-icons sort-drdn-arrow-icon"
         :style="iconStyle">keyboard_arrow_down</i>
      <i v-if="isOpen" @click.stop.prevent="isOpen=false" class="material-icons sort-drdn-arrow-icon"
         :style="iconStyle">keyboard_arrow_up</i>
    </div>

    <div v-if="isOpen" class="sort-drdn-list-outsider" @click="isOpen=false"></div>
    <ul v-if="type!=='date' && isOpen" class="sort-drdn-list" :style="listStyle" style="list-style: unset;margin-left: 0;margin-top: 0">
      <li class="sort-drdn-item" v-for="(item,idx) in list" :key="'sort-list'+idx" @click="clickTargetItem(item, idx)"
          :style="itemStyle">
        <div v-if="hasImg" style="display: flex; width: 40px;">
          <img :src="item.img" :alt="item.label+'이미지'">
        </div>
        {{ item.label }}
      </li>
    </ul>

    <!-- Date -->
    <div v-if="type==='date'" class="sort-drdn-list-date">
      <datepicker language="ko" wrapper-class="sort-date-picker-wrap" calendar-class="sort-date-picker-cal"
                  input-class="sort-date-picker-input"
                  @opened="isOpen=true" @closed="isOpen=false" @selected="selectDate" style="width:116px;"></datepicker>
      <!-- <span v-if="isDateShow===false" @click.stop.prevent="isOpen=true" style="width: 300px; position: absolute; top: 5px; left: 12px; font-size: .8rem; cursor:pointer;">{{ placeholder }}</span> -->
      <i class="material-icons" style="font-size:20px; cursor: pointer;" @click.stop.prevent="openList">date_range</i>
    </div>

    <!-- Time -->
    <!-- <div v-if="type==='time'" class="sort-drdn-list-time">
      <lp-time-picker></lp-time-picker>
      <lp-time-picker></lp-time-picker>
    </div> -->

  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  import LpTimePicker from '../common/LpTimePicker'

  export default {
    props: [
      'type', 'data', 'placeholder', 'list', 'nowOpened', 'hasImg',
      'width', 'listWidth', 'wrapPadding', 'bgColor', 'borderColor',
      'fontSize', 'wrapHeight', 'iconSize', 'iconColor', 'ulStyle',
      'fontSize', 'wrapHeight', 'iconSize', 'ulStyle', 'listDirection',
      'listIndex', // 드롭다운이 for문 안에 있을 경우 리스트에서의 인덱스
    ],
    components: {
      Datepicker, LpTimePicker
    },
    data() {
      return {
        isOpen: false,
        selectedVal: '',
        selectedImg: '',
        regionList: [],
        // isDateShow: false
      }
    },
    created() {
      if (this.data !== undefined) {
        this.selectedVal = this.data;
      }

      else if (this.placeholder !== undefined) {
        this.selectedVal = this.placeholder;
        if (this.hasImg === true) {
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].label === this.selectedVal) {
              this.selectedImg = this.list[i].img;
            }
          }
        }
      }

      // 오픈 시 열려있는 다른 리스트 닫기
      if (this.nowOpened !== this.type) {
        this.isOpen = false;
      }
    },
    watch: {
      nowOpened(n) {
        if (n !== this.type) {
          this.isOpen = false;
        }
      },
      data(n) {
        this.selectedVal = n;
      },
      list(n) {
        if (this.data !== undefined)
          this.selectedVal = this.data
        else
          this.selectedVal = this.placeholder;
      },
      placeholder(n) {
        this.selectedVal = n;
      }
    },
    computed: {
      containerStyle() {
        if (this.type === 'date') {
          return 'width: 128px';
        }
      },
      wrapperStyle() {
        let style = {};

        if (this.width !== undefined) {
          style.width = this.width + 'px';
        }
        if (this.bgColor !== undefined) {
          style.backgroundColor = this.bgColor;
        }
        if (this.borderColor !== undefined) {
          style.border = '1px solid ' + this.borderColor;
        }
        if (this.fontSize !== undefined) {
          style.fontSize = this.fontSize;
        }
        if (this.wrapHeight !== undefined) {
          style.height = this.wrapHeight;
        }
        if (this.wrapPadding !== undefined) {
          style.padding = this.wrapPadding;
        }

        if (this.type === 'date') {
          //style.width = '100px';
          style.width = '114px';
        }

        return style;
      },
      iconStyle() {
        let style = {};

        if (this.iconSize !== undefined) {
          style.fontSize = this.iconSize;
        }
        if (this.iconColor !== undefined) {
          style.color = this.iconColor;
        }

        return style;
      },
      listStyle() {
        let style = {};

        // if ( this.listWidth !== undefined ) {
        //   style.width = this.listWidth + 'px';
        // }
        if (this.ulStyle !== undefined) {
          style = this.ulStyle;
        }
        if (this.width !== undefined) {
          style.width = this.width - 2 + 'px';
        }
        if (this.borderColor !== undefined) {
          style.border = '1px solid ' + this.borderColor;
        }
        if (this.fontSize !== undefined) {
          style.fontSize = this.fontSize;
        }
        if (this.wrapHeight !== undefined) {
          style.top = this.wrapHeight;
        }
        if (this.listDirection !== undefined) {
          if (this.listDirection === 'bottom') {
            style.bottom = this.wrapHeight !== undefined ? this.wrapHeight : '0';
            style.top = 'unset';
          }
          else if (this.wrapHeight !== undefined)
            style.top = this.wrapHeight;
        }

        return style;
      },
      itemStyle() {
        let style = {};

        if (this.bgColor !== undefined) {
          style.backgroundColor = this.bgColor;
        }
        if (this.fontSize !== undefined) {
          style.fontSize = this.fontSize;
        }
        if (this.hasImg === true) {
          style.display = 'flex';
          style.alignItems = 'center';
        }

        return style;
      }
    },
    methods: {
      openList() {
        this.isOpen ? this.isOpen = false : this.isOpen = true;
        this.$root.$emit('openListType', this.type);
      },
      selectDate(date) {
        let selDate = moment(date).format('YY-MM-DD');
        this.selectedVal = selDate;
        this.$emit('onSelect', moment(date).format('YYYY-MM-DD'));
        // this.isDateShow = true;
      },
      clickTargetItem(item, idx) {
        this.selectedVal = item.label;
        this.selectedImg = item.img;
        this.$emit('onSelect', item.value);
        this.$emit('onSelectItem', item);
        this.$emit('onSelectAll', item, idx, this.listIndex);
        this.isOpen = false;
      }
    }
  }
</script>

<style>
  .sort-date-picker-wrap {
    height: 32px;
  }

  .sort-date-picker-cal {
    top: 46px;
  }

  .sort-date-picker-input {
    width: 100%;
    border: none;
    background: transparent;
    /*border: 1px solid #dbdbdb;*/
    border-radius: 3px;
    height: 30px;
    padding-left: 12px;
    color: transparent;
    cursor: pointer;
  }
</style>


<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'

  .lp-sort-drop-down-container
    font-size 0.9rem
    position relative

  .sort-drdn-select-wrapper
    color: #363636;
    box-shadow inset 0 1px 2px rgba(10, 10, 10, 0.1);
    border 1px solid #dbdbdb
    background white
    display flex
    justify-content space-between
    align-items center
    border-radius 4px
    height 32px
    padding 8px
    //font-size .8rem
    cursor pointer

  .sort-drdn-select-item
    display flex
    align-items center
    cursor pointer

  .sort-drdn-arrow-icon
    font-size 1.1rem
    color #064160
    cursor pointer

  .sort-drdn-list
    position absolute
    top 32px
    left 0
    box-shadow 3px 4px 8px 0px #999
    background-color #fff
    border-radius 3px
    max-height 270px
    overflow-y auto
    z-index 1
    //font-size .8rem
    cursor pointer

  .sort-drdn-item
    background white
    padding 8px 12px
    cursor pointer

  .sort-drdn-item:hover
    background #ddd

  .sort-drdn-list-outsider
    position fixed
    top 0
    left 0
    right 0
    bottom 0

  .sort-drdn-list-date
    position absolute
    top 0
    left 0
    display flex
    width 142px
    align-items center
    cursor pointer

  .lp-sort-drop-down-container > ul
    margin 0

  /*@media (max-width: 440px)
    .lp-sort-drop-down-container
      position unset*/
</style>
